import { clone } from 'helpers/global.helper/global.helper'

import i18n from 'i18next'
import elplanStore from 'store/elplan/elplan'
import { snapshot } from 'valtio'

export function parseWildcardItems(items: UiConfigPropsItem[]): UiConfigPropsItem[] {
  const { bid_types } = snapshot(elplanStore)
  const newItems: UiConfigPropsItem[] = []

  items.forEach((item) => {
    if (item?.data_id?.includes('*')) {
      const bidType = bid_types.find((bidType) => item.data_id.includes(bidType.type) && item.data_id.includes('*'))
      if (bidType) {
        const wildCardAmount = bidType.amount ?? 10
        for (let i = 1; i <= wildCardAmount; i++) {
          const newItem = clone(item)
          newItem.data_id = getBidDatasetId(item.data_id, i)
          const translatedTitle =
            bidType.type === 'blockbid'
              ? i18n.t('Block bid')
              : bidType.type === 'profilebid'
                ? i18n.t('Profile bid')
                : 'bid'
          const modifiedTitle = translatedTitle[0].toUpperCase() + translatedTitle.slice(1)

          newItem.title = `${modifiedTitle} ${i}`

          newItem.order = (item.order ?? 0) + i

          newItem.color = getBidColorBasedOnOrderAndType(bidType.type as 'blockbid' | 'profilebid', i)
          newItems.push(newItem)
        }
      }
      //TODO: Handle other wildcard cases beside for block bid and profile bid (but how would we know how many * we should generate?)
    }
  })
  const filteredItems = items.filter((item) => !item?.data_id?.includes('*'))
  return filteredItems.concat(newItems).toSorted((a, b) => (a.order ?? 0) - (b.order ?? 0))
}

export function parseWildcardVariables(variables: (string | number)[]): (string | number)[] {
  const { elplan_info_id, bid_types } = snapshot(elplanStore)

  if (elplan_info_id === 0) {
    //make sure we do not do this unless the system has a elplan module
    return variables
  }

  const newVariables: string[] = []
  variables.forEach((variable) => {
    if (typeof variable === 'string') {
      const bidType = bid_types.find((bidType) => variable.includes(bidType.type) && variable.includes('*'))

      if (bidType) {
        const wildCardAmount = bidType.amount ?? 10
        for (let i = 1; i <= wildCardAmount; i++) {
          const bidDatasetId = getBidDatasetId(variable, i)
          newVariables.push(bidDatasetId)
        }
      }
      //TODO: Handle other wildcard cases beside for block bid and profile bid (but how would we know how many * we should generate?)
    }
  })

  const withoutWildCard = variables.filter(
    (variable) => (typeof variable === 'string' && !variable.includes('*')) || typeof variable === 'number'
  )
  return withoutWildCard.concat(newVariables)
}

// aurora-django names an elplan bid dataset by replacing the `*` in its return_id with the block order.
function getBidDatasetId(string: string, index: number): string {
  return string.replace('*', String(index))
}

export function getBidColorBasedOnOrderAndType(bidType: 'blockbid' | 'profilebid', secondIndex: number): string {
  const blockBidColors = [
    '#73d453',
    '#539ed4',
    '#f35e5e',
    '#66bb6a',
    '#fa67aa',
    '#bb63ff',
    '#53d49e',
    '#7353d4',
    '#FFA500',
    '#FFD700',
  ]
  const profileBidColors = [
    '#BFEFFF',
    '#BDFCC9',
    '#ffbdd7',
    '#DABDFF',
    '#FFF9C6',
    '#A6E3E3',
    '#BFFFD9',
    '#FFDABD',
    '#FFFD9C',
    '#ffbebd',
  ]

  if (bidType === 'blockbid') {
    return blockBidColors[secondIndex % blockBidColors.length]
  }
  if (bidType === 'profilebid') {
    return profileBidColors[secondIndex % profileBidColors.length]
  }
  return 'pink'
}
